import {TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {TextFieldProps} from "@mui/material/TextField/TextField";

function computeVerificationRegex(fractionDigits: number) {
	if (fractionDigits <= 0)
		return new RegExp(`^-?[0-9]*$`);
	return new RegExp(`^-?[0-9]*([,.][0-9]{0,${fractionDigits}})?$`);
}

const defaultFractionDigits = 6;
const defaultVerificationRegex = computeVerificationRegex(defaultFractionDigits);

export interface NumberFieldProps {
	readonly fractionDigits?: number;
	readonly onValueChange?: (value: number | null) => void;
}

export function NumberField(props: TextFieldProps & NumberFieldProps) {
	const [value, setValue] = useState<string>("");

	const fractionDigits = props.fractionDigits ?? defaultFractionDigits;

	const verificationRegex = props.fractionDigits === undefined
		? defaultVerificationRegex
		: computeVerificationRegex(fractionDigits);

	useEffect(() => {
		if (props.value !== null && props.value !== undefined && props.value.toString() !== Number(value).toString())
			setValue(Number(Number(props.value).toFixed(fractionDigits)).toString());
		// should only depend on the changes from the props
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.value]);
	const realProps: any = {...props};
	delete realProps.fractionDigits;
	delete realProps.onValueChange;
	return <TextField
		{...realProps}
		value={value}
		onChange={event => {
			if (verificationRegex.test(event.target.value)) {
				setValue(event.target.value);
				if (props.onChange)
					props.onChange(event);
				if (props.onValueChange) {
					const value = Number(event.target.value.replaceAll(",", "."));
					props.onValueChange(value);
				}
			}
		}}
	/>;
}

